import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { Row , Col, Container, Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { saveNewletter, loadSettingData } from "../../actions/homePageActions";
import Contact from '../ContactModal';

const Footer = () => {

    let newDate = new Date();
    let year = newDate.getFullYear();

    const dispatch = useDispatch();

    useEffect(() => {
    dispatch(loadSettingData());
    }, [dispatch]);
    
    const {
      settingsData,
    } = useSelector((state) => ({
      settingsData: state.settingsData,
    }));
    
    // console.log('settingsData',settingsData);
    const { register, handleSubmit } = useForm();
    
    const [ showMailModal, getMailModal ] = useState(false);
    const [getFormError, setFormError] = useState(false);

    const onSubmit = (data) => {
    //   console.log('data',data);
      const request = {};
      if(!!data.newsletter_email){
        request.email = data.newsletter_email;
        setFormError(false);
        // setLoader(true);
        dispatch(saveNewletter(request));
      }
      else{
        setFormError(true);
      }
    };

    // console.log('showMailModal',showMailModal);

    return (
        <> 

         <footer>
             <Container>
             <Row>
                <Col md={4}>
                    <div className="social">
                        { settingsData.twitter_link && (
                        <a href={settingsData.twitter_link} target="_blank" rel="noreferrer"><img alt="Kanchana Gupta" src={process.env.REACT_APP_PUBLIC_URL + "/assets/images/twiter.svg" } /></a>
                        )}
                        { settingsData.facebook_link && (
                        <a href={settingsData.facebook_link} target="_blank" rel="noreferrer"><img alt="Kanchana Gupta" src={process.env.REACT_APP_PUBLIC_URL + "/assets/images/facebook.svg" } /></a>
                        )}
                        { settingsData.linkedin_link && (
                        <a href={settingsData.linkedin_link + "?trk=people-guest_people_search-card"} target="_blank" rel="noreferrer"><img alt="Kanchana Gupta" src={process.env.REACT_APP_PUBLIC_URL + "/assets/images/linkdin.svg" } /></a>
                        )}
                        { settingsData.instagram_link && (
                        <a href={settingsData.instagram_link} target="_blank" rel="noreferrer"><img alt="Kanchana Gupta" src={process.env.REACT_APP_PUBLIC_URL + "/assets/images/instagrm.png" } /></a>  
                        )}             
                        <img alt="Kanchana Gupta" onClick={()=>getMailModal(true)} src={process.env.REACT_APP_PUBLIC_URL + "/assets/images/email.png" } />
                    </div> 
                 </Col>

                <Col md={4}>
                    <span className="coppyright">© {year} { settingsData.copyright_text ? settingsData.copyright_text : "" }</span> 
                </Col> 
 
                <Col md={4}>
                    <div className="newslatter">
                        <h5>Newsletter</h5>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                        <Form.Control type="email" id="newsletter_email" placeholder="Your email address" 
                        {...register("newsletter_email")} />
                        <Button type="submit" className="subscribe">Subscribe</Button> 
                        </Form>
                        { getFormError ? (
                          <b className="text-danger text-left">
                            Please enter email
                          </b>
                        ) : "" }
                    </div>
                </Col> 
             
             </Row>
          </Container>
        </footer>   

        <Contact 
        show={showMailModal}
        onHide={() => getMailModal(false)}
        centered
        size="xl"
        className="mentor_modal"
        />
 
 <a href="/#" className="gototop"><img alt="Kanchana Gupta" src="./assets/images/top_arrow.jpg" /></a>
 
        </>
    )
}
export default Footer;